import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import api from "assets/services/api";
import useAuth from "hooks/useAuth";


function ModalDeleteRouting(props) {
  const { storageId } = useAuth();
  const [br, setBR] = useState(false);
  const [controlSnack, setControlSnack] = useState(false);
  const showNotification = place => {
    switch (place) {
      case "br":
        if (!br) {
          setBR(true);
          setTimeout(function () {
            setBR(false);
            setControlSnack(false);
          }, 6000);
        }
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    if (controlSnack) showNotification("br")
  }, [controlSnack]);
  async function handleDeleteRoutesOfDelivery(e) {
    e.preventDefault();
    const response = await api.delete(`/routing/${storageId}/${props.props.id}`, {
    });
    if (response.data.error) {
      return alert(response.data.error);
    }
    props.getAllRouting();
    props.onHide();
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Deletar Rota de entrega
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleDeleteRoutesOfDelivery}>
        <Modal.Body>
          <h4> Tem certeza que deseja deletar esse Rota de entrega?</h4>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center">
            <Button color="success" type="submit" >
              Deletar
            </Button>
            <Snackbar
              place="br"
              color="success"
              icon={AddAlert}
              message="Rota de entrega deletada com sucesso"
              open={br}
              closeNotification={() => setBR(false)}
              close
            />
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ModalDeleteRouting;